import { SET_NAVIGATION } from 'src/vuex/mutation-type'
import _ from 'lodash'

// initial state
const state = []

// mutations
const mutations = {
  [SET_NAVIGATION] (state, data) {
    state.splice(0, state.length)
    _.forIn(data, xs => {
      state.push(xs)
    })
  }
}

export default {
  state,
  mutations
}



// WEBPACK FOOTER //
// ./src/vuex/modules/navigation.js